import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pantry-ingredient-food-list-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryIngredientFoodView = _resolveComponent("PantryIngredientFoodView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foodList, (item, index) => {
      return (_openBlock(), _createBlock(_component_PantryIngredientFoodView, {
        key: index,
        categoryName: item.categoryName,
        data: item.list,
        selectName: _ctx.selectName,
        onOnSelect: _ctx.onSelectIngredient
      }, null, 8, ["categoryName", "data", "selectName", "onOnSelect"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}